const operators = [
  { name: 'greater than (>)', value: 'gt' },
  { name: 'greater than or equal to (>=)', value: 'gte' },
  { name: 'less than (<)', value: 'lt' },
  { name: 'less than or equal to (<=)', value: 'lte' },
  { name: 'equal to (=)', value: 'eq' },
  { name: 'not equal to (!=)', value: 'ne' },
  { name: 'includes', value: 'in' },
  { name: 'start with', value: 'sw' },
  { name: 'ends with', value: 'ew' },
]
/**
 *
 * @param {*} query Qlik Alerting query definition for Qlik Sense
 * @param {*} condition
 */
const parseCondition = (
  query,
  conditions,
  { concat, separator = '; ', addIndex } = {}
) => {
  let thisConditions
  if (!Array.isArray(conditions)) thisConditions = [conditions]
  else thisConditions = conditions
  const result = thisConditions.map((condition, i) => {
    const {
      type,
      index,
      operator,
      value,
      compare,
      aggr,
      limit,
      factor,
      offset,
      offsetIsPercent,
    } = condition
    try {
      const columns = [...query.dimensions, ...query.measures]
      let description = ''
      // eslint-disable-next-line radix
      if (addIndex) description = `${(10 + parseInt(i)).toString(20).toUpperCase()} - `
      description += `${columns[index].label || columns[index].def} ${
        operators.find(each => each.value === operator).name
      } `
      switch (type) {
        case 'history':
          if (limit > 1) description += `the last ${limit} scans (${aggr})`
          else description += 'the last scanned value'
          break
        case 'set':
          if (aggr === 'std')
            description += `the standard deviation (${
              (factor > 0 ? '+' : '') + factor
            })`
          else description += `the ${factor || ''} ${aggr} `
          break
        case 'measure':
          description += columns[compare].label || columns[compare].def
          break
        case 'manual':
          description += `${value || 0}`
          break
        default:
          return ''
      }
      if (type !== 'manual' && offset) {
        description += ` ${offset > 0 ? '+' : ''}${offset || ''}${
          offsetIsPercent ? ' %' : ''
        }`
      }
      return description
    } catch (e) {
      return ''
    }
  })
  if (concat) return result.join(separator)
  return result
}

module.exports = parseCondition
